export default __webpack_public_path__ + "static/media/m-assortedcheese.d74017cc.png";